export default __webpack_public_path__ + "static/sales-b1d0c3f3fc274b5cadca999ae8b9fc45.png";